import React from 'react';
import type { CitizenScreen } from '../../types/navigation';
import { useStore } from '../../contexts/StoreContext';
import { MobileHeader } from '../../components/mobile/MobileHeader';
import { VehicleTimeline } from '../../components/shared/VehicleTimeline';
import { StatusBadge } from '../../components/shared/StatusBadge';
import { stageInfo } from '../../utils/caseStatus';
export function ProgressScreen({
  pcr,
  go
}: {
  pcr: string;
  go: (s: CitizenScreen) => void;
}) {
  const {
    getCase
  } = useStore();
  const c = getCase(pcr);
  if (!c) return <p className="p-6" data-id="element-1117" data-mp="1am4bs0grdvwy">কেস পাওয়া যায়নি।</p>;
  const s = stageInfo(c);
  const div = c.division;
  return <>
      <MobileHeader appName="ডিএমপি যানবাহন সেবা" title="আবেদনের অগ্রগতি" onBack={() => go({
      name: 'case',
      pcr
    })} data-id="element-1118" data-mp="15qyp2zfj8d7t" />
      <div className="flex-1 overflow-y-auto no-scrollbar px-4 py-4 space-y-3" data-id="element-1119" data-mp="3qf3d9xx1l07x">
        <div className="card flex items-center justify-between p-3" data-id="element-1120" data-mp="3qd0dwna01uqj">
          <div data-id="element-1121" data-mp="3mcge1by1kd0p"><p className="font-mono text-sm font-bold text-navy" data-id="element-1122" data-mp="3mcgf7f9s2j2a">{c.pcr}</p><p className="text-xs text-ink-muted" data-id="element-1123" data-mp="1ve3kfry62m92">{c.regNo}</p></div>
          <StatusBadge label={s.label} tone={s.tone} size="sm" data-id="element-1124" data-mp="20dg6wbl4lrb4" />
        </div>
        <div className="card p-4" data-id="element-1125" data-mp="20bdjlzbcyca3"><VehicleTimeline c={c} data-id="element-1126" data-mp="1mdyrgmtpzqef" /></div>
        <div className="card p-4 text-xs text-ink-muted" data-id="element-1127" data-mp="1mcx35gnp17er">
          <p className="font-bold text-ink text-sm mb-1" data-id="element-1128" data-mp="1qf0gkatxam2o">দায়িত্বপ্রাপ্ত অফিস</p>
          <p data-id="element-1129" data-mp="1qh4wxs90ddju">{div} · {c.station?.station ?? c.assignedStation}</p>
          <p className="mt-1" data-id="element-1130" data-mp="1cmauy7ib3j63">সাহায্যের জন্য বিভাগীয় অফিসে PCR নম্বরসহ যোগাযোগ করুন।</p>
        </div>
      </div>
    </>;
}